import React from 'react';
import CollapsibleMenu from 'ui/properties-panel/collapsible-menu';
import DynamicTextButton from './action-tab-content-components/dynamic-text-button';
import SourceModeButton from './action-tab-content-components/source-mode-button';
import LinkAction from './action-tab-content-components/link-action';

export default class ActionTabContent extends React.Component {
  constructor(props) {
    super(props);
  }

  textLink() {
    return (
      <CollapsibleMenu title="Text Link">
        <LinkAction {...this.props} />
      </CollapsibleMenu>
    );
  }

  dtrMenu() {
    if (window.editor.page.getConfigValue('allowDTR')) {
      return (
        <CollapsibleMenu title="Dynamic Text Replacement" plan="pro">
          <DynamicTextButton
            changeHandler={this.props.changeHandler}
            defaultText={this.props.defaultText}
          />
        </CollapsibleMenu>
      );
    }
  }

  sourceMenu() {
    return (
      <CollapsibleMenu title="Source Code">
        <SourceModeButton changeHandler={this.props.changeHandler} />
      </CollapsibleMenu>
    );
  }

  render() {
    return (
      <div className='action-container'>
        {this.textLink()}
        {this.dtrMenu()}
        {this.sourceMenu()}
      </div>
    );
  }
}

ActionTabContent.propTypes = {
  passParams: React.PropTypes.bool,
  target: React.PropTypes.string,
  urlAction: React.PropTypes.string,
  changeHandler: React.PropTypes.func,
  urlValue: React.PropTypes.string,
  defaultText: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/ui/inline-text/action-tab-content.jsx